"use client";

import { useCallback, useEffect } from "react";
import { usePathname, useRouter } from "next/navigation";
import { IDX_LAUNCHLAB_LIVE_PATH } from "@/config/idxLaunchlabAppConfig";
import { teardownHeavyTokenWidgets } from "@/lib/navigation/teardownHeavyTokenWidgets";
import { getPageScrollElement } from "@/lib/scroll/pageScroll";

const IDX_LAUNCHLAB_PATH_PREFIX = "/idx-launchlab";

function pathWithoutQuery(pathname) {
  return String(pathname || "").split("?")[0].split("#")[0];
}

export function useLaunchlabNav() {
  const pathname = usePathname();
  const router = useRouter();
  const pathBase = pathWithoutQuery(pathname);
  const isLaunchlabLivePage = pathBase === IDX_LAUNCHLAB_LIVE_PATH;
  const isLaunchlabRoute = pathBase.startsWith(IDX_LAUNCHLAB_PATH_PREFIX);

  useEffect(() => {
    if (isLaunchlabLivePage) return;
    const warm = () => router.prefetch(IDX_LAUNCHLAB_LIVE_PATH);
    if (typeof requestIdleCallback === "function") {
      const id = requestIdleCallback(warm);
      return () => cancelIdleCallback(id);
    }
    const id = window.setTimeout(warm, 0);
    return () => window.clearTimeout(id);
  }, [pathname, isLaunchlabLivePage, router]);

  const warmLaunchlab = useCallback(() => {
    router.prefetch(IDX_LAUNCHLAB_LIVE_PATH);
  }, [router]);

  const onLaunchlabClick = useCallback(
    (e) => {
      teardownHeavyTokenWidgets();

      if (isLaunchlabLivePage) {
        e.preventDefault();
        getPageScrollElement()?.scrollTo({ top: 0, behavior: "auto" });
      }
    },
    [isLaunchlabLivePage],
  );

  return { onLaunchlabClick, warmLaunchlab, isLaunchlabRoute, isLaunchlabLivePage };
}
